<!--
	TEMPLATE
-->
<template>

	<div class="editable-price" @click.prevent="isEditView = true">
		<div v-if="!isEditView">
			{{ item && item.name ? item.name : '' }}
		</div>

		<div v-if="isEditView">
      <select v-model="mode">
        <option value="">Select</option>
        <option value="new">New</option>
        <option value="existing">Existing</option>
      </select>
      <v-autocomplete :items="items" v-model="item" :get-label="getLabel" :component-item='template' @update-items="updateItems" v-if="mode == 'existing'"></v-autocomplete>
      <a href="javascript:;" @click.prevent="$router.push('/owners/'+item.id)" v-if="mode == 'existing'">Open {{ item.name }}'s profile</a>
      <!--
      :get-label="getLabel" :component-item='template' @update-items="updateItems"
        <auto-complete url="" :options="options" anchor="title" :onFocus="getData" :onSelect="newValue" v-if="mode == 'existing' && !exists"></auto-complete>
  			<auto-complete url="" :options="options" anchor="title" :onFocus="getData" :initValue="exists" :onSelect="newValue" v-if="mode == 'existing' && exists"></auto-complete>
      -->
      <a :href="newUrl" v-if="mode == 'new'">{{ newTxt ? newTxt : 'Create new' }}</a>
		</div>
	</div>

</template>

<!--
	SCRIPT
-->
<script>
import utils from '@/libs/mixins.js';
import vModelNested from '@/libs/vModelNested.js';
import ItemTemplate from '@/components/AutoCompleteTemplate.vue'


export default {
	props: {
    exists: Object,
    options: Array,
    newUrl: String,
    newTxt: String,
    remode: String,
		isEditView: Boolean
	},
	data: function() {
		return {
			hasErrors: false,
      mode: '',
      items: [],
      item: {},
      template: ItemTemplate
		}
	},
  created: function() {
    console.log('this.options',this.options);
    if (this.exists && this.exists.name) {
      this.item = this.exists;
      this.mode = 'existing';
    }
    if (this.remode && this.remode != '') {
      this.mode = this.remode;
    }
  },
	mixins: [utils],
	methods: {
    getLabel (item) {
      if (item) {
        return item.name
      } else {
        return ''
      }
    },
    updateItems (text) {
      console.log('this.options',this.options);
      const reitems = this.options.filter(i => {
        return i.name.indexOf(text) !== -1
      });
      console.log('reitems',reitems);
      this.items = reitems;
    },
    getData(obj){
      console.log(Autocomplete.methods().getData());
      Autocomplete.data().showList = true;
      console.log('result',Autocomplete.data());
      console.log('got data',this.options);
    },
		newValue(value) {
			this.item = value;
      this.isEditView = false;
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/editable-items/EditableAutocomplete.vue